var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardActiveNative = function SvgCardActiveNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.088 8.137H4.59c-.908 0-1.644.737-1.644 1.644v11.772c0 .908.736 1.644 1.644 1.644h21.498c.908 0 1.644-.736 1.644-1.644V9.781c0-.907-.736-1.644-1.644-1.644Z",
    fill: "#4376B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.732 11.902H2.946v3.765h24.786v-3.765Z",
    fill: "#305992"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.91 5H2.412C1.504 5 .768 5.736.768 6.644v11.772c0 .908.736 1.644 1.644 1.644H23.91c.908 0 1.644-.736 1.644-1.644V6.644c0-.908-.736-1.644-1.644-1.644Z",
    fill: "#274673"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.175 7.692H4.163a.377.377 0 0 0-.376.376v1.965c0 .207.168.376.376.376h3.012a.376.376 0 0 0 .377-.377V8.069a.377.377 0 0 0-.377-.376Z",
    fill: "#6794C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.704 14.933a2.403 2.403 0 0 1 1.218-2.09c-.37-.212-.791-.32-1.218-.313a2.432 2.432 0 0 0-2.383 3.067 2.434 2.434 0 0 0 3.6 1.457 2.415 2.415 0 0 1-1.217-2.12Z",
    fill: "#305992"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.108 12.53c-.43 0-.85.118-1.218.339a2.41 2.41 0 0 1 0 4.185 2.43 2.43 0 1 0 1.218-4.524Z",
    fill: "#305992"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.108 14.933a2.416 2.416 0 0 0-1.218-2.09 2.409 2.409 0 0 0 0 4.186 2.429 2.429 0 0 0 1.218-2.096Z",
    fill: "#6794C9"
  })));
};
export default SvgCardActiveNative;